import React from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useTranslation } from "react-i18next";
type PropsType = {
  label?: string;
  name?: string;
  register?: any;
  required?: boolean;
  watch?: any;
  type?: string;
  min?: string;
  max?: string;
  errors?: any;
  icon?: any;
  parentClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  onChange?: any;
  start_with?: any;
};

const Input: React.FC<PropsType> = ({
  name,
  label,
  register,
  required,
  watch,
  type = "text",
  errors,
  min,
  max,
  icon,
  parentClassName,
  labelClassName,
  start_with,
  disabled = false,
  onChange,
}) => {
  const { i18n } = useTranslation();
  const validationStyle = () => {
    if (errors && errors[name]) {
      return "ring-red-600 ring-2";
    } else {
      return "";
    }
  };
  const responseiveIconDirectionIcon = () => {
    if (icon && i18n.language === "ar") {
      return "right-0 rounded-r-xl";
    } else if (icon && i18n.language === "en") {
      return "left-0 rounded-l-xl";
    } else {
      return "right-0 rounded-r-xl";
    }
  };
  const responseiveIconDirection = () => {
    if (!icon) {
      return "px-3";
    } else if (icon && i18n.language === "ar") {
      return "pr-11";
    } else if (icon && i18n.language === "en") {
      return "pl-11";
    } else {
      return "";
    }
  };

  return (
    <div className={`flex w-full flex-col ${parentClassName}`}>
      <div className={`relative flex items-center w-full h-[35px] my-2 group`}>
        <input
          {...register(name, {
            onChange,
          })}
          required={required}
          aria-label={label}
          label={label ? label : name}
          aria-labelledby={label ? label : name}
          type={type}
          autoComplete={type && type === "password" ? "new-password" : "off"}
          min={min}
          max={max}
          disabled={disabled}
          className={`w-full h-full  ${
            disabled ? "cursor-not-allowed opacity-30" : ""
          }  text-base font-bold outline-none ${responseiveIconDirection()} appearance-none bg-white shadow rounded-md text-[#585757] ${validationStyle()}`}
        />
        {/* {icon ? (
          <div
            className={`absolute ${responseiveIconDirectionIcon()} h-12  flex items-center justify-center w-10 bg-desert-storm-dark `}
          >
            {icon()}
          </div>
        ) : (
          ""
        )} */}
      </div>
      {errors && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <small className="px-3 -mt-2 text-red-600">{message}</small>
          )}
        />
      )}
    </div>
  );
};

export default Input;
